'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.extractBuffers = extractBuffers;
exports.splitHost = splitHost;
exports.mentionsNick = mentionsNick;
exports.userModePrefix = userModePrefix;
exports.userMode = userMode;
exports.queryStringVal = queryStringVal;
exports.networkErrorMessage = networkErrorMessage;
exports.parseIrcUri = parseIrcUri;
exports.dedotObject = dedotObject;
exports.replaceObjectProps = replaceObjectProps;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extractBuffers(str) {
    var spaceIdx = str.indexOf(' ');
    if (spaceIdx === -1) spaceIdx = str.length;

    var bufferNames = str.substr(0, spaceIdx).split(',');
    var keys = str.substr(spaceIdx + 1).split(',');

    var buffers = [];
    bufferNames.forEach(function (bufferName, idx) {
        buffers.push({
            name: bufferName,
            key: keys[idx] || ''
        });
    });

    return buffers;
}

function splitHost(uri) {}

function mentionsNick(input, nick) {
    var punc = ',.!:;-+)]?¿\\/<>@';

    var idx = input.toLowerCase().indexOf(nick.toLowerCase());
    if (idx === -1) {
        return false;
    }

    var startIdx = input.lastIndexOf(' ', idx);
    if (startIdx === -1) {
        startIdx = 0;
    } else {
        startIdx++;
    }

    var endIdx = input.indexOf(' ', idx);
    if (endIdx === -1) {
        endIdx = input.length;
    }

    var segment = input.substring(startIdx, endIdx);
    var potentialNick = _lodash2.default.trim(segment, punc);

    return potentialNick.toLowerCase() === nick.toLowerCase();
}

function userModePrefix(user, buffer) {
    if (!user.buffers[buffer.id]) {
        return '';
    }

    var modes = user.buffers[buffer.id].modes;
    if (modes.length === 0) {
        return '';
    }

    var network = buffer.getNetwork();
    var netPrefixes = network.ircClient.network.options.PREFIX;

    var prefix = _lodash2.default.find(netPrefixes, function (p) {
        return modes.indexOf(p.mode) > -1;
    });

    return prefix ? prefix.symbol : '';
}

function userMode(user, buffer) {
    if (!user.buffers[buffer.id]) {
        return '';
    }

    var modes = user.buffers[buffer.id].modes;
    if (modes.length === 0) {
        return '';
    }

    var network = buffer.getNetwork();
    var netPrefixes = network.ircClient.network.options.PREFIX;

    var prefix = _lodash2.default.find(netPrefixes, function (p) {
        return modes.indexOf(p.mode) > -1;
    });

    return prefix ? prefix.mode : '';
}

function queryStringVal(_name, _url) {
    var url = _url || window.location.href;
    var name = _lodash2.default.escapeRegExp(_name);
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);

    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function networkErrorMessage(err) {
    var errs = {
        err_unknown_host: 'Unknown domain name or host',
        err_forbidden: 'Forbidden to connect',
        err_timeout: 'Took too long to connect',
        err_refused: 'The server refused the connection',
        err_tls: 'Could not connect securely',
        err_proxy: 'The Kiwi IRC server had an error'
    };

    return errs[err] || 'Unknown error';
}

function parseIrcUri(str) {
    var reg = /(?:(ircs?):\/\/)?([a-z.0-9]+)(?::(?:(\+)?([0-9]+)))?(?:\/([^?]*))?(?:\?(.*))?/;
    var connections = [];
    str.split(';').forEach(function (connectionString) {
        if (!connectionString) {
            return;
        }

        var m = connectionString.match(reg);

        if (!m) {
            return;
        }

        var tls = m[1] === 'ircs' || !!m[3];
        var params = (0, _create2.default)(null);
        (m[6] || '').split('&').forEach(function (p) {
            var parts = p.split('=');
            if (parts.length === 2) {
                params[parts[0].toLowerCase()] = parts[1];
            }
        });

        var channels = m[5] || params.channel || '';
        channels = (0, _lodash2.default)(channels.split(',')).compact().map(function (_channelName) {
            var hasPrefix = _channelName[0] === '#' || _channelName[0] === '&';

            var channelName = hasPrefix ? _channelName : '#' + _channelName;

            return channelName;
        });

        connections.push({
            tls: tls,
            server: m[2],
            port: parseInt(m[4] || (tls ? 6697 : 6667), 10),
            channels: channels,
            nick: params.nick || '',
            encoding: params.encoding || 'utf8',
            params: params
        });
    });

    return connections;
}

function dedotObject(confObj, _place) {
    var place = _place || [];
    var regex = /\w\.\w/;

    _lodash2.default.each(confObj, function (val, key) {
        var ourPlace = place.concat([key]);
        if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object') {
            dedotObject(confObj[key], ourPlace);
            return;
        }
        if (regex.test(key)) {
            delete confObj[key];
            _lodash2.default.set(confObj, ourPlace.join('.'), val);
        }
    });
}

function replaceObjectProps(target, source) {
    (0, _keys2.default)(target).forEach(function (prop) {
        return delete target[prop];
    });
    (0, _keys2.default)(source).forEach(function (prop) {
        target[prop] = source[prop];
    });
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["helpers"]) window._kiwi_exports["helpers"] = {};
window._kiwi_exports["helpers"]["Misc"]
window._kiwi_exports.helpers.Misc = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Misc.js
// module id = uN9+
// module chunks = 1